import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  crearMedicamento: ["payload"],
  crearMedicamentoLoading: null,
  crearMedicamentoSuccess: ["crearMedicamentoData"],
  crearMedicamentoFailure: ["crearMedicamentoError"],

  cancelarMedicamento: ["payload"],
  cancelarMedicamentoLoading: null,
  cancelarMedicamentoSuccess: ["cancelarMedicamentoData"],
  cancelarMedicamentoFailure: ["cancelarMedicamentoError"],

  getMedicamento: ["payload"],
  getMedicamentoLoading: null,
  getMedicamentoSuccess: ["getMedicamentoData"],
  getMedicamentoFailure: ["getMedicamentoError"],

  consultarMedicamentos: ["payload"],
  consultarMedicamentosLoading: null,
  consultarMedicamentosSuccess: ["consultarMedicamentosData"],
  consultarMedicamentosFailure: ["consultarMedicamentosError"],

  reactivarMedicamento: ["payload"],
  reactivarMedicamentoLoading: null,
  reactivarMedicamentoSuccess: ["reactivarMedicamentoData"],
  reactivarMedicamentoFailure: ["reactivarMedicamentoError"],

  limpiarDatosMedicamento: ["payload"],
  limpiarDatosMedicamentoLoading: null,

  formMedicamentoDiagnostico: ["payload"],
  formMedicamentoDiagnosticoLoading: null,
  formMedicamentoDiagnosticoSuccess: ["formMedicamentoDiagnosticoData"],

  getMedicamentosDiagnostico: ["payload"],
  getMedicamentosDiagnosticoLoading: null,

  modificarDiagnosticoDefinitivo: ["payload"],
  modificarDiagnosticoDefinitivoLoading: null,

  confirmarDiagnosticoDefinitivo: ["payload"],
  confirmarDiagnosticoDefinitivoLoading: null,

  descargarReporteVoucher: ["payload"],
  descargarReporteVoucherSuccess: ["descargarReporteVoucherData"],
  descargarReporteVoucherLoading: null,

  buscarMedicamentosOrdsInfoplan: ["payload"],
  buscarMedicamentosOrdsInfoplanLoading: null,
  buscarMedicamentosOrdsInfoplanSuccess: ["buscarMedicamentosOrdsInfoplanData"],
  buscarMedicamentosOrdsInfoplanFailure: ["buscarMedicamentosOrdsInfoplanError"],

  notificarReclamacion: ["payload"],
  notificarReclamacionLoading: null,
  notificarReclamacionSuccess: ["notificarReclamacionData"],
  notificarReclamacionFailure: ["notificarReclamacionError"],
});

export { Types };

export default Creators;

